.sn-security {
  display: flex;
  flex-direction: column;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: map-get($spacings, 3xl);
    background-color: var(--color-system-success-light);
    border-radius: var(--radius-size-lg);
    padding: map-get($spacings, md);

    @include above($breakpoint-desktop) {
      padding: map-get($spacings, xl);
    }

    @include above($breakpoint-desktop-md) {
      padding: map-get($spacings, 2xl);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: 1fr;
    gap: map-get($spacings, md) map-get($spacings, 2xl);

    @include above($breakpoint-desktop) {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  &__item {
    display: flex;
    align-items: flex-start;
    gap: map-get($spacings, xs); // 8px — Figma
  }

  &__check {
    flex-shrink: 0;
    color: var(--color-system-success);
    margin-top: 4px;
  }

  &__item-content {
    flex: 1;

    strong {
      font-weight: 700;
    }
  }

  &__item-title {
    display: inline;
    font-weight: 700;

    h3,
    .me-heading {
      display: inline;
      font: inherit;
      color: inherit;
      margin: 0;
    }
  }

  .me-heading--4 {
    font-size: map-get($font-sizes, 2xl);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, 3xl);
    }

    @include above($breakpoint-desktop-md) {
      font-size: map-get($font-sizes, 4xl);
    }
  }

  .me-heading--6 {
    font-size: 24px;
    line-height: 32px;
  }

  .me-text {
    font-size: map-get($font-sizes, md);
    line-height: map-get($line-heights, lg);

    @include above($breakpoint-desktop) {
      font-size: map-get($font-sizes, xl);
    }
  }
}
